import { render, staticRenderFns } from "./blok-html.vue?vue&type=template&id=2f4642d3&scoped=true&"
import script from "./blok-html.vue?vue&type=script&lang=js&"
export * from "./blok-html.vue?vue&type=script&lang=js&"
import style0 from "./blok-html.vue?vue&type=style&index=0&id=2f4642d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4642d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4642d3')) {
      api.createRecord('2f4642d3', component.options)
    } else {
      api.reload('2f4642d3', component.options)
    }
    module.hot.accept("./blok-html.vue?vue&type=template&id=2f4642d3&scoped=true&", function () {
      api.rerender('2f4642d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-html.vue"
export default component.exports